import React from "react"
import { IconButton } from '@material-ui/core';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import addIcon from "../../../../images/iconoAdd.svg";
import saveIcon from "../../../../images/iconGuardar.svg";
import clearIcon from "../../../../images/clear.png"
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCodeBranch,faFileAlt,faDollarSign,faLaptop,faUserSlash,faFileSignature,faHandshakeSlash,faShippingFast,faVoicemail,faCommentSlash,faClipboardList,faAngry,faCreditCard,faHeadset,faPhoneSlash, faCalendarCheck, faInfoCircle, faTools, faCarCrash, faIdCard, faArrowRight, faClock, faUserCheck, faUsers, faCarSide, faFile, faLock, faUnlock, faPhone, faPen, faSave, faIndustry } from '@fortawesome/free-solid-svg-icons'
import { convertToLocalTime, isUserInRole, parseJwtToken, urlToB64 } from "../../../../commonFunctions/commonFunctions";
import unlocked from "../../../../images/desbloqueado2.svg"
import { ADMIN } from "../../../../Constantes/userRoles";
import { selectCurrentCase } from "../../../../redux/currentCase/selectors";
import { InputClickToCall } from "./InputClickToCall";
import { FactoryMenu } from "./FactoryMenu";
import { selectContractCase } from "../../../../redux/contract/selectors";
import { selectUserRoles } from "../../../../redux/authentication/selectors";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    fontSize: 20,
  },
  dividerH: {
    marginLeft: 10,
    marginRight: 10
  },
  clickToCallEditButton:{
    fontSize: ".90rem",
    padding: "0 5px",
    color: "#3B5158"
  },
  secondTlfNumber:{
    color: "#ff3d3d !important"
  }
}));

function getTaxonomyIcon(taxonomy) {

  if(!taxonomy){
    return <div height={25}></div>
  }

  const lowTax = taxonomy.toLowerCase()

  switch(lowTax){
    case "info taller":
      return <FontAwesomeIcon icon={faTools} />;
    case "informacion":
      return <FontAwesomeIcon icon={faInfoCircle} />;
    case "cita taller":
      return <FontAwesomeIcon icon={faCalendarCheck} />
    case "vehiculo sustitucion":
      return <FontAwesomeIcon icon={faCarCrash}/>;
    case "documentacion":
      return <FontAwesomeIcon icon={faIdCard}/>;
    case "transferida a":
      return <FontAwesomeIcon icon={faArrowRight} />
    case "fuera de horario":
      return <FontAwesomeIcon icon={faClock} />
    case "cliente vip":
      return <FontAwesomeIcon icon={faDollarSign} />
    case "centralita":
      return <FontAwesomeIcon icon={faHeadset} />
    case "entrega":
      return <FontAwesomeIcon icon={faShippingFast} />
    case "bot interrumpido":
      return <FontAwesomeIcon icon={faPhoneSlash} />  
    case "tarjeta combustible":
      return <FontAwesomeIcon icon={faCreditCard} />   
    case "queja":
      return <FontAwesomeIcon icon={faAngry} />    
    case "itv":
      return <FontAwesomeIcon icon={faClipboardList} />   
    case "no contesta":
      return <FontAwesomeIcon icon={faCommentSlash} />  
    case "contestador":
      return <FontAwesomeIcon icon={faVoicemail} />  
    case "no colabora":
      return <FontAwesomeIcon icon={faHandshakeSlash} />  
    case "multas":
      return <FontAwesomeIcon icon={faFileSignature} />
    case "no existe":
      return <FontAwesomeIcon icon={faUserSlash} />
    case "ovc":
      return <FontAwesomeIcon icon={faLaptop} />
    case "otras gestiones":
      return <FontAwesomeIcon icon={faFileAlt} />
    case "terminaciones":
      return <FontAwesomeIcon icon={faCodeBranch} />
    case "ticket fabrica":
      return <FontAwesomeIcon icon={faIndustry}/>
    case "fabrica":
        return <FontAwesomeIcon icon={faIndustry}/>
    case "":
      return <div height={25}></div>
    default:
      return <FontAwesomeIcon icon={faFile} />
  }
}

function isFactoryCase(currentCase){

  if(!currentCase)
      return false;

  const factoryStates = window.getConfig("FACTORY_CASE_STATE_IDS");
  const factoryEntryChannels = window.getConfig("FACTORY_ENTRY_CHANNEL_IDS")

  const isFactoryState = factoryStates.some(factoryState => factoryState === currentCase.stateId)
  const isFactoryEntryChannel = factoryEntryChannels.some(factoryEntryChannel => factoryEntryChannel === currentCase.entryChannelId)

  return isFactoryState || isFactoryEntryChannel

}

function Header(props){
    const {loading, currentCase, saveChanges, createCase,showNewCase,setShowNewCase,closed,plate, CNPJ, changeBlock,checkBlockClickToCall,showCallTable, editClickToCall, setEditClickToCall, handleChangeClickToCall, saveClickToCall, cancelEditClickToCall, phoneNumber} = props;
    const isLoading = loading === "succeeded" || loading === "updating" ? true : (loading === "failed" || loading === "loading") && currentCase !== null? true: false;
    const headerRedux = useSelector(selectCurrentCase)
    const userRoles = useSelector(selectUserRoles);
    const classes= useStyles()
    const user = parseJwtToken();
    const canUserSave = user!=null && (  isUserInRole(ADMIN, userRoles) || currentCase?.blockedByUserId == user.userId || !currentCase?.blockedByUserId);
    const contractCase = useSelector(selectContractCase);

    return(
        <div className={"caseform-nav"}>
          <div className="caseform-nav-info">
            <div style={{display: "flex", alignItems:"center"}}>
            {((currentCase != null && currentCase.caseId != undefined && currentCase.caseId > 0) || showNewCase) &&
            <div>
            <div style={{display: "flex", flexDirection: "row", alignItems:"baseline"}}>
              <div style={{fontSize: "18px", fontWeight: "bolder", marginBottom: "4px", color: "#3B5158" }}> 
                { headerRedux?.taxonomyLevel_1 ? getTaxonomyIcon(headerRedux.taxonomyLevel_1.value) : null} { headerRedux? headerRedux.taxonomyLevel_1?.value || <div style={{height: 20.8}} className={"placeholder-space"}></div> : <div style={{height: 20.8}} className={"placeholder-space"}></div>}
              </div>
            </div>
            <div style={{display: "flex"}}>
              <span><b>Id Caso:</b> { !showNewCase ? currentCase.caseId : "-"}</span>
              {showCallTable?<div onClick={() => props.handleShowForms("callTable")} className={"callTableIcon"} role="button" title={"Chamadas"}><FontAwesomeIcon size="xs" icon={faInfoCircle}/></div>  :<></>}     
             
              <Divider orientation={"vertical"} classes={{root:classes.dividerH}} flexItem/>
              <span>{isLoading && currentCase ? currentCase.user: <div className={"placeholder-space"}></div> }</span>
              <Divider orientation={"vertical"} flexItem classes={{root:classes.dividerH}}/>
              <span><b>Início:</b> { isLoading && !showNewCase ? dayjs(convertToLocalTime(currentCase.creationDate)).format("DD/MM/YYYY HH:mm"):  showNewCase ? dayjs(new Date()).format("DD/MM/YYYY"):''}</span>
              <Divider orientation={"vertical"} flexItem classes={{root:classes.dividerH}}/>
              <span><b>Fim:</b> {isLoading&& !showNewCase && dayjs(convertToLocalTime(currentCase.closeDate)).format("DD/MM/YYYY HH:mm") !== "Invalid Date" ?
              dayjs(convertToLocalTime(currentCase.closeDate)).format("DD/MM/YYYY HH:mm")
              : <div style={{display:"inline"}}>-</div>}</span>
              <Divider orientation={"vertical"} flexItem classes={{root:classes.dividerH}}/>
              <span style={{display: "flex"}}><b>Telefone: </b>{isLoading && currentCase?.phoneNumber 
                ? <> <span style={{display: !editClickToCall?  "none" : "flex"}}><InputClickToCall onChange={handleChangeClickToCall} value={phoneNumber}/><span style={{display:"flex", alignItems:"baseline"}}><IconButton title="Salvar" classes={{root: classes.clickToCallEditButton}} onClick={saveClickToCall}><FontAwesomeIcon fontSize={"14px"} size="xs" icon={faSave}/></IconButton><IconButton title="Cancelar" classes={{root: classes.clickToCallEditButton}} onClick={cancelEditClickToCall}><i  style={{fontSize: "12px", color: "#3B5158 !important"}} className="dx-icon-clear"></i></IconButton></span></span>
                     <span style={{display: editClickToCall?  "none" : "flex"}}>
                      <span id="clickToCall" style={{color:"#3B5158"}}><FontAwesomeIcon size="xs" icon={faPhone}/> {phoneNumber}</span>
                      {!closed && <IconButton title="Editar número de telefone" classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><FontAwesomeIcon  fontSize={"14px"} size="xs" icon={faPen}/></IconButton>}  </span>     
                     {/* <span style={{display: editClickToCall?  "none" : "flex"}}> <a id="clickToCall" onClick={e=>checkBlockClickToCall(e)} title="Iniciar chamada" style={{color:"#3B5158"}} href={`tel:${phoneNumber}:${currentCase.customerCNPJ || CNPJ || 0}:${currentCase.caseId}:${0}:SOLUTION4FLEET:${urlToB64(currentCase.caseId)}:0`}><FontAwesomeIcon size="xs" icon={faPhone}/> {phoneNumber}</a> {!closed && <IconButton title="Editar número de telefone" classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><FontAwesomeIcon  fontSize={"14px"} size="xs" icon={faPen}/></IconButton>}  </span> */}
                    {/* href={`tel:${phoneNumber}:${currentCase.customerCNPJ || CNPJ || 0}:${currentCase.caseId}:${0}:ALPHABET:BMW:${urlToB64(currentCase.caseId)}:0`}  */}
                    
                  </>               
                : <><span style={{display: !editClickToCall?  "none" : "flex"}}><InputClickToCall onChange={handleChangeClickToCall} value={phoneNumber}/><span style={{display:"flex", alignItems:"baseline"}}><IconButton title="Salvar" classes={{root: classes.clickToCallEditButton}} onClick={saveClickToCall}><FontAwesomeIcon fontSize={"14px"} size="xs" icon={faSave}/></IconButton><IconButton title="Cancelar" classes={{root: classes.clickToCallEditButton}} onClick={cancelEditClickToCall}><i  style={{fontSize: "12px", color: "#3B5158 !important"}} className="dx-icon-clear"></i></IconButton></span></span>
                  <span style={{display: editClickToCall?  "none" : "flex"}}><span>-</span> {currentCase?.caseId !== 0 && !closed && <IconButton title="Editar número de telefone" classes={{root: classes.clickToCallEditButton}} onClick={()=>setEditClickToCall(true)}><FontAwesomeIcon  fontSize={"14px"} size="xs" icon={faPen}/></IconButton>}</span>
                  </>
                }
              </span>
              
            </div>
            </div>
          }
          </div>
        </div>
        {/* {currentCase && isFactoryCase(contractCase) && !closed && !showNewCase && <FactoryMenu processId={currentCase?.factoryProcessId} showForms={props.handleShowForms} disabledButtom={props.disabledButtom} showAddFactoryCommentForm={props.showAddFactoryCommentForm} showRegressFactoryCaseForm={props.showRegressFactoryCaseForm} showAdvanceFactoryCaseForm={props.showAdvanceFactoryCaseForm} regressCase={props.regressCase} disabledRegressCase={props.disabledRegressCase}/>} */}
        {currentCase && !closed && !showNewCase && <IconButton onClick={changeBlock}>{currentCase.blockedByUser? <FontAwesomeIcon style={{fontSize:20}} color="#800000" icon={faLock} title={`Chamado bloqueado por ${currentCase? currentCase.blockedByUser: "Usuario"}`}/> : <img width={20} title={"Bloquear caso"} src={unlocked}/>}</IconButton>}
        <IconButton disabled={CNPJ == undefined ? true : false} onClick={setShowNewCase}><img src={ !showNewCase  ? addIcon : clearIcon} alt="adicionar" title={!showNewCase  ? "Novo chamado" : "Descartar"} width={20}/></IconButton> 
        <IconButton disabled={currentCase === null || (!canUserSave ? true : closed) || !isLoading} onClick={showNewCase == true ? createCase : saveChanges}><img src={saveIcon} alt="salver" title={"Salvar"} width={20}/></IconButton> 
        <div style={{backgroundColor: props.showDocumentation ? "#3B5158" :'' }} onClick={() => props.handleShowForms("documentation")} className={props.disabledButtom.documentation ? "caseform-nav-message" : "caseform-nav-message active"} role="button" title={"Templates"}><DescriptionOutlinedIcon  classes={{root: classes.iconButton}}/></div>
        <div style={{backgroundColor: props.showMessageForm ? "#3B5158" :'' }} onClick={() => props.handleShowForms("messageForm")} className={props.disabledButtom.messageForm ? "caseform-nav-message" : "caseform-nav-message active"} role="button" title={"Enviar mensagens"}><ChatBubbleOutlineIcon  classes={{root: classes.iconButton}}/></div>
     </div>

  )

}


export { Header }